import React from 'react'
import ReactModal from 'react-modal'
import { useDispatch } from 'react-redux'
import { Capacitor } from '@capacitor/core'

import { t } from 'translations'
import { Button } from 'components/Forms'
import { closeModal } from 'store/actions/modals'
import { CostIcon } from 'components/UI'
import { Spinner } from 'ui'

// Bind the modal to the root element
if (!process.env.IS_TEST) {
  ReactModal.setAppElement('#root')
}

const BaseModal = ({
  children,
  title,
  titleVar,
  primaryAction,
  primaryActionText,
  secondaryAction,
  hideButtons,
  preventClosing,
  summary,
  summaryVar,
  shouldCloseOnOverlayClick,
  basicText,
  destructive,
  noPadding,
  tOptions,
  wideModal,
  isLoading,
  showCostIcon
}) => {
  const dispatch = useDispatch()

  return (
    <ReactModal
      isOpen
      className={`merinio-modal${noPadding ? ' p-0' : ''}${wideModal ? ' merinio-modal-wide' : ''}`}
      overlayClassName={`merinio-modal-overlay${Capacitor.isNativePlatform() ? ' is-mobile-app' : ''}`}
      shouldFocusAfterRender
      // These two lines are required to allow closing when the user clicks outside of the modal
      onRequestClose={() => (preventClosing ? null : dispatch(closeModal()))}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
    >
      {isLoading ? (
        <div className="text-center">
          <Spinner size="lg" />
        </div>
      ) : (
        <div className="w-100 h-100 d-flex flex-column">
          <div className={`flex-fill ${hideButtons ? '' : ' mb-2'}`}>
            {title ? (
              <>
                <h4 className={noPadding ? ' px-3 pt-3' : ''}>
                  {t(basicText ? title : `${title}.TITLE`, { ...tOptions, ...titleVar })} {showCostIcon ? <CostIcon /> : null}
                </h4>
                {t(basicText ? summary : `${title}.SUMMARY`, { ...tOptions, ...summaryVar }) && (
                  <div className={noPadding ? ' px-3' : ''}>{t(`${title}.SUMMARY`, { ...tOptions, ...summaryVar })}</div>
                )}
              </>
            ) : null}

            {children}
          </div>
          {!hideButtons && (
            <div>
              {/* This button only appears if a primary action exists */}
              {(() => {
                if (typeof primaryAction === 'function') {
                  return (
                    <Button
                      className={`btn btn-${destructive ? 'danger' : 'primary'} mr-2`}
                      onClick={() => {
                        primaryAction()
                        dispatch(closeModal())
                      }}
                    >
                      {t(basicText ? primaryActionText : `${title}.PRIMARY_ACTION`, tOptions)}
                    </Button>
                  )
                } else {
                  return primaryAction
                }
              })()}

              <Button
                className="btn btn-outline-secondary"
                onClick={() => {
                  dispatch(closeModal())
                  if (secondaryAction) secondaryAction()
                }}
              >
                {t(`actions.CLOSE`, tOptions)}
              </Button>
            </div>
          )}
        </div>
      )}
    </ReactModal>
  )
}

export default BaseModal
